import { render, staticRenderFns } from "./OperationBaseDetailed.vue?vue&type=template&id=0da68eea&scoped=true&"
import script from "./OperationBaseDetailed.vue?vue&type=script&lang=js&"
export * from "./OperationBaseDetailed.vue?vue&type=script&lang=js&"
import style0 from "./OperationBaseDetailed.vue?vue&type=style&index=0&id=0da68eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da68eea",
  null
  
)

export default component.exports